import { getFontFullPath } from '@/Pages/Clip/SideBar/FontSelector/constants';
import { CaptionLineConfig, CaptionStyles, HighlightTypeEnum } from '@/domains/asset';
import { TransitionInEffect } from '@/App/remotion/libs/transitions/types';

const neo: Partial<CaptionStyles> = {
  theme_preset: 'neo',
  pageStyle: {
    color: '#7ffa32',
    textShadow: '-2px -1px 20px #07f82c'
  },
  wordStyle: {
    highlightType: HighlightTypeEnum.None,
    inactive: {
      color: '#7ffa32'
    }
  },
  font_location: getFontFullPath('SpaceMono-Bold.ttf'),
  caps: true,
  line_config: CaptionLineConfig.OneWord,
  font_size: 72,
  transitions: {
    pageIn: TransitionInEffect.None
  }
};

export default neo;
